export const downloadWarningsCsv = (warnings: string[], fileName: string): void => {
  if (!warnings.length || typeof document === 'undefined') return;

  const lines = ['"STT","Cảnh báo"', ...warnings.map((warning, index) => `"${index + 1}","${warning.replace(/"/g, '""')}"`)];
  const blob = new Blob(['\uFEFF' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName.endsWith('.csv') ? fileName : `${fileName}-warnings.csv`;
  anchor.click();
  URL.revokeObjectURL(url);
};